'use client';

import { redirect, useParams, usePathname } from 'next/navigation';
import AppHeader from '../Layout/AppHeader';
import { TabComponent } from '../Shared/Tab';
import { ROUTES } from '@/constants/routes';

const APILayoutContent = () => {
  const pathname = usePathname();
  const { id } = useParams();

  const resolveActiveTab = () => {
    // Normalize pathname (remove trailing slash if any)
    const normalizedPath = pathname.replace(/\/$/, '');

    // Extract last segment
    const lastSegment = normalizedPath.split('/').pop();

    if (normalizedPath === ROUTES.API.ROOT || lastSegment === 'api') {
      return '';
    }

    const validTabs = ['webhook-management', 'api'] as const;

    return validTabs.includes(lastSegment as 'webhook-management' | 'api')
      ? lastSegment
      : 'webhook-management';
  };

  const activeTab = resolveActiveTab() || '';

  if (id) {
    return null;
  }

  return (
    <div>
      <div className='mb-20'>
        <AppHeader
          title='API Keys'
          subtitle='Take a look into your API calls and consumption.'
        />
      </div>

      <TabComponent
        tabOptions={[
          { label: 'API & WEBHOOK', id: '' },
          { label: 'WEBHOOK MANAGEMENT', id: 'webhook-management' },
        ]}
        onTabChange={(value) => {
          if (value === '') {
            redirect(ROUTES.API.ROOT);
          } else {
            redirect(`${ROUTES.API.ROOT}/${value}`);
          }
        }}
        defaultValue={activeTab}
        variant='outline'
        triggerStyles='text-base!'
      />
    </div>
  );
};

export default APILayoutContent;
